module.exports = __webpack_public_path__ + "img/triangle_arrow_gray_down.580ee03a.svg";